import { createStore, combineReducers } from "redux";
import { userReducer } from "./profile/user";
import { eventReducer } from "./events/event";
import { paymentReducer } from "./payments/payment";
import { promotionReducer } from "./promotions/promotion";
import { generalInfoReducer } from "./subscriptions/general_info";
import { personalInfoReducer } from "./subscriptions/personal_info";
import { paymentInfoReducer } from "./subscriptions/payment_info";

export enum ACTION_TYPE {
  APP_GENERAL = "app/general",
}

/**
 * Abstract data-type shared between
 * personal_info and payment_info
 */
export type IBaseInfo = {
  first_name: string;
  last_name: string;
  email: string;
  contact: string;
  address: string;
  city: string;
  country: string;
  pin_code: string;
};

export const APP_VERSION = "2.4.2";

export type IAppState = {
  version: string;
  appName: string;
};

export const initialState: IAppState = {
  version: APP_VERSION,
  appName: `Power Ministry Events Registration`,
};

export function appReducer(
  state = initialState,
  action: { type: ACTION_TYPE; payload: any }
) {
  return state;
}

export const store = createStore(
  combineReducers({
    app: appReducer,
    user: userReducer,
    event: eventReducer,
    payment: paymentReducer,
    promotion: promotionReducer,
    general_info: generalInfoReducer,
    payment_info: paymentInfoReducer,
    personal_info: personalInfoReducer,
  })
);
